import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Button, Col, Row } from "react-bootstrap";
import { Business } from "../authentication/components/forms/business";

import { notification } from "utils/notification";

export const NewBusiness = () => {
  const methods = useForm();
  return (
    <Row>
      <Col md="6" className="custom-box p-5">
        <FormProvider {...methods}>
          <form>
            <h1 className="mb-4">فرم اطللاعات کسب و کار شما </h1>
            <Business />
           <div className="d-flex flex-row-reverse">
           <Button
              className="my-4 w-25 "
              onClick={() => {
                notification("این قسمت درحال توسعه می باشد", "default");
              }}
            >
              ثبت
            </Button>
           </div>
          </form>
        </FormProvider>
      </Col>
    </Row>
  );
};
